// Codice Fiscale — calcolo lato client per pazienti italiani ed esteri.
// Copre ~300 comuni italiani più popolosi + tutti gli stati esteri attivi
// secondo la tabella ufficiale Agenzia delle Entrate (codici Belfiore Z001–Z999).
// Per casi non coperti, l'utente può digitare manualmente il CF nel form.
//
// Riferimento algoritmo: https://it.wikipedia.org/wiki/Codice_fiscale
// Riferimento codici stati esteri: Agenzia delle Entrate — Archivio Comuni e Stati Esteri

// Mesi → lettera (jan=A, feb=B, mar=C, apr=D, mag=E, giu=H, lug=L, ago=M, set=P, ott=R, nov=S, dic=T)
const MONTH_LETTERS = "ABCDEHLMPRST";

// Tabelle per il carattere di controllo
const CTRL_ODD = {
  "0": 1, "1": 0, "2": 5, "3": 7, "4": 9, "5": 13, "6": 15, "7": 17, "8": 19, "9": 21,
  A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21, K: 2, L: 4, M: 18,
  N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};
const CTRL_EVEN = {
  "0": 0, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9,
  A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9, K: 10, L: 11, M: 12,
  N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19, U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25,
};
const CTRL_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

// Comuni italiani (top ~300 per popolazione) → codice Belfiore
// Se un comune manca, il CF non viene calcolato e l'utente lo scrive a mano
export const BELFIORE = {
  // Città capoluogo + capoluoghi di provincia + comuni > 30k abitanti (subset)
  ROMA: "H501", MILANO: "F205", NAPOLI: "F839", TORINO: "L219", PALERMO: "G273",
  GENOVA: "D969", BOLOGNA: "A944", FIRENZE: "D612", BARI: "A662", CATANIA: "C351",
  VENEZIA: "L736", VERONA: "L781", MESSINA: "F158", PADOVA: "G224", TRIESTE: "L424",
  BRESCIA: "B157", "REGGIO DI CALABRIA": "H224", "REGGIO CALABRIA": "H224",
  "REGGIO NELL'EMILIA": "H223", "REGGIO EMILIA": "H223", MODENA: "F257",
  "PRATO": "G999", PARMA: "G337", LIVORNO: "E625", CAGLIARI: "B354", "FOGGIA": "D643",
  PERUGIA: "G478", "RAVENNA": "H199", RIMINI: "H294", "SALERNO": "H703",
  FERRARA: "D548", "SASSARI": "I452", MONZA: "F704", "SIRACUSA": "I754",
  "GIUGLIANO IN CAMPANIA": "E054", LATINA: "E472", "PESCARA": "G482",
  BERGAMO: "A794", "TARANTO": "L049", "FORLÌ": "D704", "FORLI": "D704",
  "TRENTO": "L378", "VICENZA": "L840", "TERNI": "L117", "NOVARA": "F952",
  ANCONA: "A271", "PIACENZA": "G535", ANDRIA: "A285", "AREZZO": "A390",
  "UDINE": "L483", "CESENA": "C573", LECCE: "E506", "PESARO": "G479",
  "BARLETTA": "A669", "ALESSANDRIA": "A182", "LA SPEZIA": "E463",
  "PISTOIA": "G713", CATANZARO: "C352", "PISA": "G702", "BRINDISI": "B180",
  "TREVISO": "L407", "GUIDONIA MONTECELIO": "E263", "MARSALA": "E974",
  "GELA": "D960", "APRILIA": "A341", "TIVOLI": "L182", "VITERBO": "M082",
  "SESTO SAN GIOVANNI": "I690", "POTENZA": "G942", "COMO": "C933",
  "CASORIA": "B990", "AFRAGOLA": "A064", "PAVIA": "G388", "TORRE DEL GRECO": "L259",
  "CALTANISSETTA": "B429", "LUCCA": "E715", CINISELLO_BALSAMO: "C707",
  "CINISELLO BALSAMO": "C707", "L'AQUILA": "A345", "AQUILA": "A345",
  "TRAPANI": "L331", "COSENZA": "D086", "VARESE": "L682", "SIENA": "I726",
  "ASTI": "A479", "MATERA": "F052", "IMOLA": "E289", "CARPI": "B819",
  "QUARTU SANT'ELENA": "H118", "LAMEZIA TERME": "M208", "VITTORIA": "M088",
  "PORDENONE": "G886", "RAGUSA": "H163", "CROTONE": "D122", "AGRIGENTO": "A089",
  "BOLZANO": "A952", "SCANDICCI": "B962", "SAVONA": "I480", "CAMPOBASSO": "B519",
  "ACERRA": "A024", "OLBIA": "G015", "VELLETRI": "L719", "ROVIGO": "H620",
  "MOLFETTA": "F284", "ALTAMURA": "A225", "FIUMICINO": "M297", "PORTICI": "G902",
  "LEGNANO": "E514", "ORISTANO": "G113", "CATANZARO LIDO": "C352",
  "CAVA DE' TIRRENI": "C361", "MANTOVA": "E897", "BENEVENTO": "A783",
  "BAGHERIA": "A546", "FANO": "D488", "TERAMO": "L103", "ANZIO": "A323",
  "SIRACUSA": "I754", "CASTELLAMMARE DI STABIA": "C129", "MODICA": "F258",
  "CARRARA": "B832", "ISERNIA": "E335", "SAN GIULIANO MILANESE": "H930",
  "CIAMPINO": "C605", "BATTIPAGLIA": "A717", "SANREMO": "I138",
  "PIOMBINO": "G687", "IMPERIA": "E290", "CERIGNOLA": "C514", "MANFREDONIA": "E885",
  "MASSA": "F023", "VIGEVANO": "L872", "TREVIGLIO": "L400", "GALLARATE": "D869",
  "SAN GIORGIO A CREMANO": "H892", "SAN SEVERO": "I158", "CASTELLANZA": "C139",
  "AVELLINO": "A509", "NUORO": "F979", "MONTEROTONDO": "F611", "CINQUEFRONDI": "C710",
  "CAMPI BISENZIO": "B507", "LECCO": "E507", "FROSINONE": "D810", "ENNA": "C342",
  "SUZZARA": "L020", "CROTONE": "D122", "LODI": "E648", "SCAFATI": "I483",
  "GROSSETO": "E202", "TERMOLI": "L113", "TRANI": "L328", "MELFI": "F104",
  "ACIREALE": "A028", "TREZZANO SUL NAVIGLIO": "L432", "MERANO": "F132",
  "LICATA": "E573", "SIRACUSA": "I754", "TERMINI IMERESE": "L112",
  "CASERTA": "B963", "TERNI": "L117", "ISCHIA": "E329", "ROVERETO": "H612",
  "MAZARA DEL VALLO": "F061", "SANT'ANTIMO": "I293", "AVERSA": "A512",
  "PIOSSASCO": "G691", "FORMIA": "D708", "BUSTO ARSIZIO": "B300",
  "MAROSTICA": "E967", "TORTONA": "L304", "SIENA": "I726", "CHIETI": "C632",
  "CANTU": "B639", "CANTÙ": "B639", "PADOVA": "G224",
  "VIAREGGIO": "L833", "COLLEGNO": "C860", "ALGHERO": "A192", "SAN SEVERO": "I158",
  "MONREALE": "F377", "SESTO FIORENTINO": "I684", "ORBASSANO": "G087",
  "OSTUNI": "G187", "MOLA DI BARI": "F280", "CARBONIA": "B745", "SORA": "I838",
  "BIELLA": "A859", "MOLFETTA": "F284", "SPOLETO": "I921", "SETTIMO TORINESE": "I703",
  "BUSSOLENGO": "B296", "CASTELLI CALEPIO": "C136", "COLLEGNO": "C860",
  "CIVITAVECCHIA": "C773", "TORREMAGGIORE": "L273", "GROTTAFERRATA": "E210",
  "MONOPOLI": "F376", "CIVITANOVA MARCHE": "C770", "MARINO": "E958",
  "SEZZE": "I712", "ROSETO DEGLI ABRUZZI": "F585", "GIULIANOVA": "E058",
  "VELLETRI": "L719", "GORIZIA": "E098", "CANOSA DI PUGLIA": "B619",
};

// -----------------------------------------------------------------
// Stati esteri (codici Belfiore Z1xx–Z7xx) — Agenzia delle Entrate
// Include tutti gli stati attualmente attivi + varianti di denominazione
// -----------------------------------------------------------------
export const STATI_ESTERI = {
  // ---------- EUROPA (Z1xx) ----------
  ALBANIA: "Z100", ANDORRA: "Z101", AUSTRIA: "Z102", BELGIO: "Z103",
  BULGARIA: "Z104", "CITTA' DEL VATICANO": "Z106", "CITTA DEL VATICANO": "Z106",
  VATICANO: "Z106", "SANTA SEDE": "Z106",
  DANIMARCA: "Z107", "FAER OER": "Z108", "ISOLE FAER OER": "Z108",
  FINLANDIA: "Z109", FRANCIA: "Z110",
  GERMANIA: "Z112", GIBILTERRA: "Z113",
  "REGNO UNITO": "Z114", "GRAN BRETAGNA": "Z114", INGHILTERRA: "Z114",
  "GRAN BRETAGNA E IRLANDA DEL NORD": "Z114", UK: "Z114",
  GRECIA: "Z115", IRLANDA: "Z116", EIRE: "Z116", ISLANDA: "Z117",
  LIECHTENSTEIN: "Z119", LUSSEMBURGO: "Z120", MALTA: "Z121",
  "ISOLA DI MAN": "Z122", "MAN": "Z122",
  MONACO: "Z123", "PRINCIPATO DI MONACO": "Z123",
  "ISOLE NORMANNE": "Z124", "ISOLE DEL CANALE": "Z124",
  NORVEGIA: "Z125", "PAESI BASSI": "Z126", OLANDA: "Z126",
  POLONIA: "Z127", PORTOGALLO: "Z128", ROMANIA: "Z129",
  "SAN MARINO": "Z130", SPAGNA: "Z131", SVEZIA: "Z132", SVIZZERA: "Z133",
  UNGHERIA: "Z134", UCRAINA: "Z138",
  BIELORUSSIA: "Z139", "RUSSIA BIANCA": "Z139",
  MOLDOVA: "Z140", MOLDAVIA: "Z140",
  ESTONIA: "Z144", LETTONIA: "Z145", LITUANIA: "Z146",
  MACEDONIA: "Z148", "MACEDONIA DEL NORD": "Z148", "REPUBBLICA DI MACEDONIA": "Z148",
  CROAZIA: "Z149", SLOVENIA: "Z150",
  "BOSNIA ERZEGOVINA": "Z153", "BOSNIA-ERZEGOVINA": "Z153",
  "BOSNIA ED ERZEGOVINA": "Z153", BOSNIA: "Z153",
  RUSSIA: "Z154", "FEDERAZIONE RUSSA": "Z154",
  SLOVACCHIA: "Z155",
  "REPUBBLICA CECA": "Z156", CECHIA: "Z156", "CECA REPUBBLICA": "Z156",
  MONTENEGRO: "Z157", SERBIA: "Z158", KOSOVO: "Z160",

  // ---------- ASIA (Z2xx) ----------
  AFGHANISTAN: "Z200", "ARABIA SAUDITA": "Z203", BAHREIN: "Z204", BAHRAIN: "Z204",
  BHUTAN: "Z205", BIRMANIA: "Z206", MYANMAR: "Z206",
  BRUNEI: "Z207", CAMBOGIA: "Z208", "SRI LANKA": "Z209",
  CINA: "Z210", "REPUBBLICA POPOLARE CINESE": "Z210",
  CIPRO: "Z211", "ISOLE COCOS": "Z212",
  "COREA DEL SUD": "Z213", COREA: "Z213", "REPUBBLICA DI COREA": "Z213",
  "COREA DEL NORD": "Z214",
  "EMIRATI ARABI UNITI": "Z215", "EMIRATI ARABI": "Z215",
  FILIPPINE: "Z216", TAIWAN: "Z217", FORMOSA: "Z217",
  "GAZA": "Z218", "TERRITORIO DI GAZA": "Z218", PALESTINA: "Z218",
  GIAPPONE: "Z219", GIORDANIA: "Z220",
  INDIA: "Z222", INDONESIA: "Z223", IRAN: "Z224", IRAQ: "Z225",
  ISRAELE: "Z226", KUWAIT: "Z227", LAOS: "Z228", LIBANO: "Z229",
  MACAO: "Z231", MALDIVE: "Z232", MONGOLIA: "Z233",
  NEPAL: "Z234", OMAN: "Z235", PAKISTAN: "Z236", QATAR: "Z237",
  SIRIA: "Z240", THAILANDIA: "Z241",
  TURCHIA: "Z243", YEMEN: "Z246",
  MALESIA: "Z247", MALAYSIA: "Z247",
  SINGAPORE: "Z248", BANGLADESH: "Z249",
  VIETNAM: "Z251", ARMENIA: "Z252", AZERBAIGIAN: "Z253", "AZERBAIJAN": "Z253",
  GEORGIA: "Z254", KAZAKISTAN: "Z255", KAZAKHSTAN: "Z255",
  KIRGHIZISTAN: "Z256", KYRGYZSTAN: "Z256",
  TAGIKISTAN: "Z257", TAJIKISTAN: "Z257",
  TURKMENISTAN: "Z258", UZBEKISTAN: "Z259",

  // ---------- AFRICA (Z3xx) ----------
  NAMIBIA: "Z300", ALGERIA: "Z301", ANGOLA: "Z302",
  BURUNDI: "Z305", CAMERUN: "Z306", "CAPO VERDE": "Z307",
  "REPUBBLICA CENTRAFRICANA": "Z308", CENTRAFRICANA: "Z308",
  CIAD: "Z309", COMORE: "Z310", "ISOLE COMORE": "Z310",
  "REPUBBLICA DEL CONGO": "Z311", CONGO: "Z311",
  "REPUBBLICA DEMOCRATICA DEL CONGO": "Z312", "CONGO KINSHASA": "Z312",
  ZAIRE: "Z312",
  "COSTA D'AVORIO": "Z313", BENIN: "Z314", ETIOPIA: "Z315",
  GABON: "Z316", GAMBIA: "Z317", GHANA: "Z318", GUINEA: "Z319",
  "GUINEA BISSAU": "Z320", "GUINEA EQUATORIALE": "Z321",
  KENYA: "Z322", KENIA: "Z322", REUNION: "Z324", "LA REUNION": "Z324",
  LIBERIA: "Z325", LIBIA: "Z326", MADAGASCAR: "Z327", MALAWI: "Z328",
  MALI: "Z329", MAROCCO: "Z330", MAURITANIA: "Z331",
  MAURIZIO: "Z332", MAURITIUS: "Z332",
  MOZAMBICO: "Z333", NIGER: "Z334", NIGERIA: "Z335",
  EGITTO: "Z336", ZIMBABWE: "Z337",
  RUANDA: "Z338", RWANDA: "Z338",
  "SAO TOME E PRINCIPE": "Z341", "SAO TOME' E PRINCIPE": "Z341",
  SEICELLE: "Z342", SEYCHELLES: "Z342",
  SENEGAL: "Z343", "SIERRA LEONE": "Z344",
  SOMALIA: "Z345",
  SUDAFRICA: "Z347", "SUD AFRICA": "Z347", "REPUBBLICA SUDAFRICANA": "Z347",
  SUDAN: "Z348",
  SWAZILAND: "Z349", ESWATINI: "Z349",
  TOGO: "Z351", TUNISIA: "Z352", UGANDA: "Z353",
  BURKINA: "Z354", "BURKINA FASO": "Z354",
  ZAMBIA: "Z355", TANZANIA: "Z357", BOTSWANA: "Z358", LESOTHO: "Z359",
  MAYOTTE: "Z360", GIBUTI: "Z361", DJIBOUTI: "Z361",
  ERITREA: "Z368", "SUDAN DEL SUD": "Z369", "SOUTH SUDAN": "Z369",

  // ---------- AMERICA DEL NORD (Z4xx) ----------
  "BERMUDA": "Z400", "ISOLE BERMUDA": "Z400",
  CANADA: "Z401", GROENLANDIA: "Z402",
  "SAINT PIERRE E MIQUELON": "Z403",
  "STATI UNITI": "Z404", "STATI UNITI D'AMERICA": "Z404", USA: "Z404",
  AMERICA: "Z404",

  // ---------- AMERICA DEL CENTRO (Z5xx) ----------
  "ANTILLE OLANDESI": "Z501", BAHAMA: "Z502", BAHAMAS: "Z502",
  "COSTA RICA": "Z503", CUBA: "Z504",
  "REPUBBLICA DOMINICANA": "Z505", "SANTO DOMINGO": "Z505",
  "EL SALVADOR": "Z506", GIAMAICA: "Z507", GUADALUPA: "Z508",
  GUATEMALA: "Z509", HAITI: "Z510", HONDURAS: "Z511", BELIZE: "Z512",
  MARTINICA: "Z513", MESSICO: "Z514", NICARAGUA: "Z515",
  PANAMA: "Z516", "PANAMA'": "Z516",
  "PUERTO RICO": "Z518", "TURKS E CAICOS": "Z519",
  "ISOLE VERGINI AMERICANE": "Z520", BARBADOS: "Z522",
  GRENADA: "Z524", "ISOLE VERGINI BRITANNICHE": "Z525",
  DOMINICA: "Z526", "SAINT LUCIA": "Z527",
  "SAINT VINCENT E GRENADINE": "Z528", ANGUILLA: "Z529",
  "ISOLE CAYMAN": "Z530", CAYMAN: "Z530", MONTSERRAT: "Z531",
  "ANTIGUA E BARBUDA": "Z532", "SAINT KITTS E NEVIS": "Z533",

  // ---------- AMERICA DEL SUD (Z6xx) ----------
  ARGENTINA: "Z600", BOLIVIA: "Z601", BRASILE: "Z602", CILE: "Z603",
  COLOMBIA: "Z604", ECUADOR: "Z605", GUYANA: "Z606",
  "GUYANA FRANCESE": "Z607", "GUIANA FRANCESE": "Z607",
  SURINAME: "Z608",
  "ISOLE FALKLAND": "Z609", MALVINE: "Z609",
  PARAGUAY: "Z610",
  PERU: "Z611", "PERU'": "Z611", PERÙ: "Z611",
  "TRINIDAD E TOBAGO": "Z612", URUGUAY: "Z613", VENEZUELA: "Z614",

  // ---------- AUSTRALIA / OCEANIA (Z7xx) ----------
  AUSTRALIA: "Z700",
  "ISOLA CHRISTMAS": "Z702", "COOK": "Z703", "ISOLE COOK": "Z703",
  FIGI: "Z704", FIJI: "Z704",
  GUAM: "Z706", "IRIAN OCCIDENTALE": "Z707",
  "ISOLE MARIANNE": "Z710", "ISOLE MARSHALL": "Z711", MARSHALL: "Z711",
  MIDWAY: "Z712", NAURU: "Z713", NIUE: "Z714",
  "ISOLE NORFOLK": "Z715", "NUOVA CALEDONIA": "Z716",
  "NUOVA ZELANDA": "Z719",
  PITCAIRN: "Z722", "POLINESIA FRANCESE": "Z723",
  "ISOLE SALOMONE": "Z724", SALOMONE: "Z724",
  "SAMOA AMERICANE": "Z725", SAMOA: "Z726",
  TOKELAU: "Z727", TONGA: "Z728",
  "WALLIS E FUTUNA": "Z729",
  "PAPUA NUOVA GUINEA": "Z730", KIRIBATI: "Z731",
  TUVALU: "Z732", VANUATU: "Z733",
  PALAU: "Z734", MICRONESIA: "Z735", "STATI FEDERATI DI MICRONESIA": "Z735",
};

// Alias combinato: BELFIORE (compat) + BELFIORE_COMUNI (dataset ISTAT completo) + STATI_ESTERI
import { BELFIORE_COMUNI, COMUNI_ITALIA_DISPLAY } from "./comuniItalia";
const BELFIORE_FULL = { ...BELFIORE_COMUNI, ...BELFIORE, ...STATI_ESTERI };

// -----------------------------------------------------------------
// Helpers
// -----------------------------------------------------------------
const stripAccents = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const upper = (s) => stripAccents(String(s || "").toUpperCase().trim());
const consonants = (s) => upper(s).replace(/[^A-Z]/g, "").replace(/[AEIOU]/g, "");
const vowels = (s) => upper(s).replace(/[^A-Z]/g, "").replace(/[^AEIOU]/g, "");

function encodeLastName(last) {
  const c = consonants(last), v = vowels(last);
  return (c + v + "XXX").slice(0, 3);
}
function encodeFirstName(first) {
  const c = consonants(first);
  const code = c.length >= 4 ? c[0] + c[2] + c[3] : c;
  return (code + vowels(first) + "XXX").slice(0, 3);
}
function encodeDate(isoDob, sex) {
  // isoDob: YYYY-MM-DD, sex: "M" | "F"
  const [y, m, d] = isoDob.split("-").map(Number);
  if (!y || !m || !d) return "";
  const yy = String(y).slice(-2);
  const mm = MONTH_LETTERS[m - 1];
  const dd = String(d + (sex === "F" ? 40 : 0)).padStart(2, "0");
  return yy + mm + dd;
}
function controlChar(code15) {
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const ch = code15[i];
    sum += (i % 2 === 0 ? CTRL_ODD[ch] : CTRL_EVEN[ch]) ?? 0;
  }
  return CTRL_LETTERS[sum % 26];
}

// -----------------------------------------------------------------
// API
// -----------------------------------------------------------------
export function belfiore(comune) {
  if (!comune) return "";
  const key = upper(comune);
  return BELFIORE_FULL[key] || "";
}

export function calcCodiceFiscale({ firstName, lastName, sex, dob, birthPlace }) {
  if (!firstName || !lastName || !sex || !dob || !birthPlace) return "";
  const bel = belfiore(birthPlace);
  if (!bel) return "";
  const ln = encodeLastName(lastName);
  const fn = encodeFirstName(firstName);
  const dt = encodeDate(dob, sex);
  if (!ln || !fn || !dt) return "";
  const code15 = ln + fn + dt + bel;
  if (code15.length !== 15) return "";
  return code15 + controlChar(code15);
}

export function calcAge(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return "";
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 && age < 130 ? age : "";
}

// Suggerimenti per il datalist: comuni italiani (nomi con accenti) + stati esteri
// I comuni usano il dataset completo ISTAT (~7900 voci); gli stati esteri completano.
export const COMUNI_LIST = [
  ...COMUNI_ITALIA_DISPLAY,
  ...Object.keys(STATI_ESTERI).sort(),
];
